import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import { Badge } from '@cargomatic/ui';
const AppointmentConfirmationBadge = ({ confirmed }) => {
    const { t } = useTranslation();
    const color = confirmed ? 'brand' : 'red';
    const text = confirmed ? titleize(t('CONFIRMED')) : t('NOT_CONFIRMED');
    return (React.createElement("div", { className: "mt-1" },
        React.createElement(Badge, { color: color }, text)));
};
AppointmentConfirmationBadge.propTypes = {
    confirmed: PropTypes.bool.isRequired,
};
export default AppointmentConfirmationBadge;
